import React, { lazy } from "react";
import { Redirect } from "react-router-dom";
import RouteProp from "./interface";
import LandingLayout from "src/layouts/LandingLayout";
import AuthGuard from "src/components/AuthGuard";
import GuestGuard from "src/components/GuestGuard";
import ApprovedGuard from "src/components/ApprovedGuard";
import RedirectDefaultBroker from "src/components/RedirectDefaultBroker";
import { MOCK_SECRET_PATH } from "src/config";
import MockGuard from "src/components/MockGuard";
import BitkubGuard from "src/components/BitkubGuard";

export const routesConfig: Array<RouteProp> = [
  {
    path: `/${MOCK_SECRET_PATH}`,
    guard: MockGuard,
    routes: [
      {
        exact: true,
        path: `/${MOCK_SECRET_PATH}/mock/streaming/login`,
        component: lazy(() => import("src/viewsMock/StreamingLoginPage")),
      },
      {
        exact: false,
        path: `/${MOCK_SECRET_PATH}/stt/sso/callback`,
        component: lazy(() => import("src/viewsMock/SttCallbackPage")),
      },
    ],
  },
  {
    exact: true,
    path: "/404",
    component: lazy(() => import("src/views/FallbackPage")),
  },
  {
    exact: false,
    path: "/stt/sso/callback",
    component: lazy(() => import("src/views/RegisterSteps")),
  },
  // {
  //   exact: true,
  //   layout: LandingLayout,
  //   path: "/bitkub/guest/portfolio",
  //   guard: BitkubGuard,
  //   component: lazy(() => import("src/views/BitkubPortfolioGuess")),
  // },
  // {
  //   exact: true,
  //   layout: LandingLayout,
  //   path: "/bitkub/guest/account",
  //   guard: BitkubGuard,
  //   component: lazy(() => import("src/views/BitkubAccountGuess")),
  // },
  // {
  //   exact: true,
  //   layout: LandingLayout,
  //   path: "/bitkub/guest/faq",
  //   component: lazy(() => import("src/views/FaqPage")),
  // },
  /**
   * This will be refactored to /bitkub/... instead of /:brokerName
   */
  // {
  //   layout: LandingLayout,
  //   path: "/bitkub",
  //   routes: [
  //     {
  //       exact: true,
  //       path: "/bitkub/bot/rebalance",
  //       guard: AuthGuard,
  //       component: lazy(() => import("src/views/Bitkub/Bot/RebalanceBotPage")),
  //     },
  //   ],
  // },
  // {
  //   exact: true,
  //   layout: LandingLayout,
  //   // path: "/bitkub/bot/rebalance",
  //   path: "/bitkub/rebalance",
  //   component: lazy(() => import("src/views/Bitkub/Bot/RebalanceBotPage")),
  //   guard: AuthGuard,
  // },
  {
    layout: LandingLayout,
    path: "/:brokerName/:path",
    routes: [
      {
        exact: true,
        path: "/:brokerName/home",
        guard: GuestGuard,
        component: lazy(() => import("src/views/HomePage")),
      },
      {
        exact: true,
        path: "/:brokerName/otp",
        component: lazy(() => import("src/views/RegisterSteps/OTP")),
      },
      {
        exact: true,
        path: "/:brokerName/explore",
        component: lazy(() => import("src/views/ExplorePage")),
      },
      {
        exact: false,
        path: "/:brokerName/model",
        component: lazy(() => import("src/views/ModelPage")),
      },
      {
        exact: true,
        path: "/:broker/cookiepolicy",
        component: lazy(() => import("src/views/CookiePolicyPage")),
      },
      {
        exact: true,
        guard: AuthGuard,
        path: "/:brokerName/portfolio",
        component: lazy(() => import("src/views/PortfolioPage")),
      },
      {
        exact: true,
        guard: AuthGuard,
        path: "/:brokerName/spotGrid",
        component: lazy(() => import("src/views/SpotGridPage")),
      },
      {
        exact: true,
        guard: AuthGuard,
        path: "/:brokerName/account",
        component: lazy(() => import("src/views/AccountPage")),
      },
      {
        exact: true,
        guard: ApprovedGuard,
        path: "/:brokerName/transaction",
        component: lazy(() => import("src/views/TransactionPage")),
      },
      {
        exact: true,
        path: "/:brokerName/faq",
        component: lazy(() => import("src/views/FaqPage")),
      },
      {
        component: () => <Redirect to="/404" />,
      },
    ],
  },
  {
    component: () => <RedirectDefaultBroker />,
  },
];

export default routesConfig;
